/**
 * České skloňování délky produktu ve dnech, včetně půldnů (0,5 kroky):
 * 0.5 → „půlden", 1 → „1 den", 1.5 → „1,5 dne", 2–4 → „X dny", 5+ → „X dnů".
 */
export function formatDelkaDnu(delkaDnu: number): string {
  if (delkaDnu === 0.5) return "půlden";
  if (!Number.isInteger(delkaDnu)) {
    return `${String(delkaDnu).replace(".", ",")} dne`;
  }
  if (delkaDnu === 1) return "1 den";
  if (delkaDnu >= 2 && delkaDnu <= 4) return `${delkaDnu} dny`;
  return `${delkaDnu} dnů`;
}
